import { useEffect, useState } from 'react'
import { Input, Modal, Form, InputNumber, Select } from 'antd'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { useTranslation } from 'react-i18next'
import { debounce, trim } from 'lodash'
import { PAGE_SIZE_FULL, ROLES } from '../../helpers/constants'

const formItemLayout = {
   labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
   },
   wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
   }
}

const CreateServiceScreen = observer((props: any) => {
   const { t } = useTranslation()
   const ServiceStore = useStore('ServiceStore')
   const UserStore = useStore('UserStore')
   const { visible, onOk, onCancel } = props
   const [users, setUsers] = useState<any[]>([])

   const [form] = Form.useForm()

   useEffect(() => {
      loadUsers()
   }, [])

   const loadUsers = async () => {
      const result = await UserStore.getAllEmployees({ role: ROLES.SELLER })
      if (result?.rows) {
         setUsers(result.rows)
      }
   }

   const onFinish = async (values: any) => {
      const data: any = {
         name: trim(values.name),
         price: values.price
      }
      if (values.visibleTo && values.visibleTo.length > 0) {
         data.visibleTo = values.visibleTo
      } else {
         data.visibleTo = null
      }
      const result = await ServiceStore.createService(data)
      if (result) {
         form.resetFields()
         onOk()
      }
   }

   return (
      <Modal
         width={'68%'}
         visible={visible}
         centered
         title="Tạo dịch vụ"
         okText="Tạo"
         cancelText="Huỷ"
         onCancel={onCancel}
         onOk={form.submit}
      >
         <Form
            {...formItemLayout}
            form={form}
            name="createService"
            onFinish={debounce(onFinish, 400)}
            scrollToFirstError
         >
            <Form.Item
               name="name"
               label="Tên dịch vụ"
               rules={[
                  {
                     required: true,
                     message: 'Vui lòng nhập tên dịch vụ'
                  }
               ]}
            >
               <Input maxLength={200} />
            </Form.Item>
            <Form.Item
               name="price"
               label="Giá"
               rules={[
                  {
                     required: true,
                     message: 'Vui lòng nhập giá'
                  }
               ]}
            >
               <InputNumber
                  min={0}
                  style={{ width: '100%' }}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
               />
            </Form.Item>
            <Form.Item name="visibleTo" label="Hiển thị cho">
               <Select
                  mode="multiple"
                  allowClear
                  placeholder="Tất cả (mặc định)"
                  filterOption={(input: string, option: any) =>
                     option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
               >
                  {users.map((user: any) => (
                     <Select.Option key={user.id} value={user.id}>
                        {user.name || user.email}
                     </Select.Option>
                  ))}
               </Select>
            </Form.Item>
         </Form>
      </Modal>
   )
})

export default CreateServiceScreen
